export default __webpack_public_path__ + "assets/models/2da29c6d740481d02236d346d122c9ee.glb";